var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4118 6.0762C14.4118 8.52373 12.4494 10.4862 10.0002 10.4862C7.55175 10.4862 5.58851 8.52373 5.58851 6.0762C5.58851 3.62868 7.55175 1.66699 10.0002 1.66699C12.4494 1.66699 14.4118 3.62868 14.4118 6.0762ZM10.0002 18.3337C6.38547 18.3337 3.3335 17.7462 3.3335 15.4795C3.3335 13.212 6.40465 12.6453 10.0002 12.6453C13.6157 12.6453 16.6668 13.2328 16.6668 15.4995C16.6668 17.767 13.5957 18.3337 10.0002 18.3337Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4e6247f2c829188614d54ca4c17ffa85.svg";
export { ForwardRef as ReactComponent };